
<template>

	<setup_content :title="(!data.fixed && !not_editable) ? 'Статистический анализ' : 'Модель оценки'">
		<setup_frame>
			<template v-slot:title>
				<v-select v-if="!data.fixed && !not_editable" :clearable="false" :options="var_stat_type_options" v-model="var_stat_type" required style="width: 240px"/>
				<h6 v-else>Ценообразующие факторы</h6>
			</template>

			<variables :class="var_stat_type != 'Переменные' && 'd-none'" ref="variables" :id="id" :group_id="group_id" :data="data" :not_editable="not_editable" v-on:edit="ev => $emit('edit', ev)" />
			<correlation v-if="var_stat_type == 'Статистика'" :id="id" ref="correlation" :group_id="group_id" :data="data"/>

		</setup_frame>

		<imported_formula v-if="data.model_imported" :id="id" :group_id="group_id" :data="data" v-on:need_refresh="() => $emit('make_formula')"/>
		<setup_frame v-else-if="data.fixed || not_editable" title="Статистическая модель">
			<div v-if="data.fixed"><span v-html="data.printable_formula_html.exp"/></div>
			<div v-else class="d-flex">
				<b-col cols="3">{{ data.type }} модель</b-col>
				<span v-html="formula"/>
			</div>
		</setup_frame>
		<setup_frame v-else title="Статистические модели">
			<b-form-radio-group v-model="current_type" @change="set_model" class="set_model" :disabled="data.fixed || ! check_roles([ 'model' ])">
				<b-form-radio class="d-flex" value="Линейная">
						
						<b-col cols="3" :style="current_type == 'Линейная' ? 'text-decoration: underline;' : ''">Линейная модель</b-col>
						<span :class="!( current_type == 'Линейная' ) && 'info'" v-html="data.printable_formula_html.add"/>
						
				</b-form-radio>

				<b-form-radio class="d-flex" value="Мультипликативная степенная">	

						<b-col cols="3" :style="current_type == 'Мультипликативная степенная' ? 'text-decoration: underline;' : ''">Мультипликативная степенная модель</b-col>
						<span :class="!( current_type == 'Мультипликативная степенная' ) && 'info'" v-html="data.printable_formula_html.mult"/>
						
				</b-form-radio>

				<b-form-radio class="d-flex" value="Экспоненциальная">

						<b-col cols="3" :style="current_type == 'Экспоненциальная' ? 'text-decoration: underline;' : ''">Экспоненциальная модель</b-col>
						<span :class="!( current_type == 'Экспоненциальная' ) && 'info'" v-html="data.printable_formula_html.exp"/>

				</b-form-radio>
			</b-form-radio-group>

			<b-table v-if="!not_editable" class="mt-2 mb-4" style="font-size: 10pt;" small :items="stats" :fields="stats_fields" sort-by="model">

				<template v-slot:cell(model)="_data">

					<div v-if="data.type == _data.value" style="text-decoration: underline">{{ _data.value }}</div>
					<div v-else>{{ _data.value }}</div>

				</template>

				<template v-slot:head()="data">

					<div v-if="data.field.key == 'model'">{{ data.field.label }}</div>
					<div v-else-if="data.field.key == 'fisher'" align="center">{{ data.field.label }}</div>
					<div v-else>

						<div align="center">{{ data.field.label }}</div>
						<b-row>

							<b-col align="center">Обучающая</b-col>
							<b-col align="center">Контрольная</b-col>

						</b-row>

					</div>

				</template>

				<template v-slot:cell(fisher)="data">

					<div :style="data.item.fisher_significance ? '' : 'color: red;'" align="center">{{ format_stat(data.value, false) }}</div>

				</template>

				<template v-slot:cell()="data">

					<b-row align-v="center">

						<b-col :style="data.value.teach_invalid ? 'color: red;' : ''" align="center">

							<div v-if="data.value.teach == null || data.value.teach == undefined || data.value.teach == ''" style="font-size: 18pt;margin: -8px;">&infin;</div>
							<div v-else>{{ format_stat(data.value.teach, data.field.key != 'determination_coef') }}</div>

						</b-col>
						<b-col :style="data.value.test_invalid ? 'color: red;' : ''" align="center">

							<div v-if="data.value.test == null || data.value.test == undefined || data.value.test == ''" style="font-size: 18pt;margin: -8px;">&infin;</div>
							<div v-else>{{ format_stat(data.value.test, data.field.key != 'determination_coef') }}</div>

						</b-col>

					</b-row>

				</template>

			</b-table>

		</setup_frame>

		<setup_frame v-if="!data.fixed && !not_editable">
			<template v-slot:title>
				<v-select :clearable="false" :options="analyse_type_options" v-model="analyse_type" required style="width: 240px"/>
			</template>

			<pair :class="analyse_type != 'Парный анализ' && 'd-none'" ref="pair" :id="id" :data="data" v-on:bring_back="() => $emit('bring_back')" />

			<diff v-if="analyse_type == 'Анализ невязок'"  :id="id" :data="data" v-on:bring_back="() => $emit('bring_back')" />

		</setup_frame>

	</setup_content>

</template>

<script>

import api from "../../../../../../api"
import my_variables from "../../../../../../api/variables"
import variables from "./variables"
import correlation from "./correlation"
import pair from "./pair"
import diff from "./diff"
import imported_formula from "./imported_formula"
import setup_content from "../../setup_assets/content"
import setup_frame from "../../setup_assets/frame"

export default
{
	props :
	{
		id : String,
		group_id : String,
		data : Object,
		not_editable : Boolean,
	},

	components :
	{
		variables,
		correlation,
		pair,
		diff,
		imported_formula,
		setup_content,
		setup_frame,
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",
			
			selected_type : null,
			current_type : null,

			var_stat_type : "Переменные",
			var_stat_type_options : ["Переменные", "Статистика",],

			analyse_type : "Парный анализ",
			analyse_type_options : ["Парный анализ", "Анализ невязок",],
			
			stats : [],
			stats_fields :
			[
				{ key : "model", label : "Статистическая модель" },
				{ key : "fisher", label : "F-критерий Фишера" },
				{ key : "determination_coef", label : "Коэффициент детерминации" },
				{ key : "square_error", label : "Среднеквадратичная ошибка" },
				{ key : "variance", label : "Отношение суммы невязок к средней стоимости" },
				{ key : "average_error", label : "Средняя ошибка аппроксимации" },
			],

		}
	},

	mounted()
	{
		this.update()
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,

			handler(data)
			{
				if(data && data.type)
					this.current_type = data.type

				this.data = data
				this.$refs.variables && this.update(true)
			},
		}
	},

	calculate :
	{
		formula()
		{
			return this.data.printable_formula_html[my_variables.CE_modeling_model.getCodeByName(this.data.type)]
		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		format_stat(value, percentage = true)
		{
			if(value == null)
				return ""

			if(percentage)
			{
				const prepared_value = api.round2(Math.abs(value))

				return `${prepared_value} %`
			}

			return api.round2(Math.abs(value))
		},

		set_model(type)
		{
			var old_type = this.data.type

			this.current_type = type
			this.data.type = type
			
			api.call(this, this.service, "set_model", { id : this.id, type : type }, () => {
				this.$emit('set_steps_value', [
					{ id : 'comparative_step3_' + my_variables.CE_modeling_model.getCodeByName(old_type), text_style : undefined, },
					{ id : 'comparative_step3_' + my_variables.CE_modeling_model.getCodeByName(type), text_style : 'text-decoration: underline;', },
				])
			})
		},

		update(only_refresh_stat = false)
		{
			if(this.data == null || this.group_id == null)
				return

			var stats = []
			var add_stats =
				( name, key ) =>
					{
						var desc =
						{
							model : name
						}

						if(this.data.stats[key] != null)
						{
							if(key == "add")
							{
								if(this.data.stats[key].fisher != null)
									desc.fisher = this.data.stats[key].fisher.teach

								desc.fisher_significance = this.data.stats[key].fisher_significance.teach
								desc.determination_coef = this.data.stats[key].determination_coef
							}
							else
							{
								if(this.data.stats[key].fisher_ln != null)
									desc.fisher = this.data.stats[key].fisher_ln.teach

								desc.fisher_significance = this.data.stats[key].fisher_ln_significance.teach
								desc.determination_coef = this.data.stats[key].determination_coef_ln
							}

							desc.square_error = this.data.stats[key].square_error
							desc.variance = this.data.stats[key].variance
							desc.average_error = this.data.stats[key].average_error
						}

						stats.push(desc)
					}

			add_stats("Линейная", "add")
			add_stats("Мультипликативная степенная", "mult")
			add_stats("Экспоненциальная", "exp")

			const conf = this.data.conf
			var prepare_stat =
				( ind, key ) =>
				{
					if(stats[ind][key] != null)
					{
						stats[ind][key] = 
						{
							teach : stats[ind][key].teach,
							test : stats[ind][key].test,
						}

						if(key == "determination_coef")
						{
							stats[ind][key].teach_invalid = stats[ind][key].teach <= conf[key].teach
							stats[ind][key].test_invalid = stats[ind][key].test <= conf[key].test
						}
						else
						{
							stats[ind][key].teach_invalid = stats[ind][key].teach >= conf[key].teach * 100
							stats[ind][key].test_invalid = stats[ind][key].test >= conf[key].test * 100
						}
					}
				}
			var prepare_stats =
				ind =>
				{
					prepare_stat(ind, "average_error")
					prepare_stat(ind, "square_error")
					prepare_stat(ind, "determination_coef")
				}

			prepare_stats(0)
			prepare_stats(1)
			prepare_stats(2)

			this.stats = stats

			this.$refs.variables.update(only_refresh_stat)
		},

		format_reference(attr, value)
		{
			return api.format_reference(attr.reference, value)
		},
	}
}

</script>

<style>
.set_model label
{
	flex: 1;
	display: flex;
}
</style>
